<template src="./Positions.html"></template>

<script>
import sitesTopMenu from "@/components/sites/components/topMenu"
import Pagination from "@/components/components/pagination"
import Chart from '@/components/brand/dynamics/components/Chart';
import {createNamespacedHelpers} from 'vuex'
import SelfDateRangePicker from "@/components/components/SelfDataRagePicker"

const {mapGetters, mapActions} = createNamespacedHelpers('sites/positions')

export default {
  name: "Positions",
  components: {
    sitesTopMenu,
    Pagination,
    Chart,
    SelfDateRangePicker,
  },
  data() {

    return {
      showOverlay: false,
      searchVal: '',
      currentSiteId: this.$route.params.id,
      currentSearchEngine: 'yandex',
      currentRegionId: null,
      searchEngineList: [
        { value: 'yandex', text: 'Yandex' },
        { value: 'google', text: 'Google' },
      ],
      fields: [
        {
          key: 'brand.name',
          label: 'Бренд',
          sortable: true
        },
        {
          key: 'query',
          label: 'Запросы',
          sortable: true
        },
        {
          key: 'frequency',
          label: 'Общая частота',
          sortable: true
        },
      ],
      chartName: '',
      chartFrom: null,
      chartTo: null,
      activeQueryId: null,
      dateRange: {},
      prepareFields: [
        {
          key: 'brand.name',
          label: 'Бренд',
          sortable: true
        },
        {
          key: 'query',
          label: 'Запросы',
          sortable: true
        },
      ]
    }
  },
  methods: {
    ...mapActions([
      'GET_DATA',
      'GET_HISTORY',
    ]),
    prepareName: function (name) {
      name = name.replace(' ', '&nbsp;');
      return name
    },
    goToPage: function(page) {
      this.$store.commit('sites/positions/CURRENT_PAGE', page)
      this.GET_DATA({th: this})
    },
    perPage: function(page) {
      this.$store.commit('sites/positions/PER_PAGE', page)
      this.GET_DATA({th: this})
    },
    initPageSize: function() {
      let winHeight = window.innerHeight
      winHeight = Math.round((winHeight - 270) / 25)
      this.$store.commit('sites/positions/PER_PAGE', winHeight)
      this.$store.commit('sites/positions/CURRENT_PAGE', 1)
    },
    search: function() {
      this.$store.commit('sites/positions/SEARCH_VALUE', this.searchVal)
      this.$store.commit('sites/positions/CURRENT_PAGE', 1)
      this.GET_DATA({th: this})
    },
    reset: function() {
      this.searchVal = ''
      this.search()
    },
    sortingChanged: function (ctx) {
      this.$store.commit('sites/positions/SORT_FIELD', ctx.sortBy)
      this.$store.commit('sites/positions/SORT_DIR', ctx.sortDesc ? 'desc' : 'asc')
      this.GET_DATA({th: this})
    },
    regionChange: function () {
      // this.chartName = ''
      this.$store.commit('sites/positions/CURRENT_REGION_ID', this.currentRegionId);
      this.$store.commit('sites/positions/HISTORY_DATA', {});
      this.$store.commit('sites/positions/CURRENT_PAGE', 1)
      this.GET_DATA({th: this})
    },
    selectQuery: function (queryId, query) {
      this.activeQueryId = queryId
      this.chartName = query
      this.getChartDat()
    },
    getChartDat: function () {
      if (this.chartFrom != null && this.chartTo != null && this.activeQueryId != null) {
        this.GET_HISTORY({th: this, id: this.activeQueryId, from: this.chartFrom, to: this.chartTo});
      }
    },
    updateChart: function (val) {
      this.chartFrom = val.from
      this.chartTo = val.to
      this.getChartDat()
    },
    prepareTableField: function(data) {
      // let date_0 = null
      let date_1 = null
      let date_2 = null
      let date_3 = null
      let date_4 = null
      for (let key in data) {
        let val = data[key]
        // if (val.date_0 != 'н/д') {
        //   date_0 = val.date_0
        // }
        if (val.date_1 != 'н/д') {
          date_1 = val.date_1
        }
        if (val.date_2 != 'н/д') {
          date_2 = val.date_2
        }
        if (val.date_3 != 'н/д') {
          date_3 = val.date_3
        }
        if (val.date_4 != 'н/д') {
          date_4 = val.date_4
        }
        // copy fields
        this.prepareFields = this.fields.slice()
        // processing
        this.processingField()
      }
    },
    processingField: function () {
      for (let key in this.FIELD_HEADER) {
        let parts = key.split('_');
        this.prepareFields.push({
          key: key,
          label: parts[1].padStart(2, "0") + '.' + parts[0],
          sortable: false
        })
      }
    },
    sortPositionData: function(data) {
      // check if data is empty
      if (data == null || data.length == 0) {
        return data
      }
      // sort
      let sorted = []
      // push only isBasic=true
      for (let key in data) {
        if (data[key].isBasic == true) {
          sorted.push(data[key])
        }
      }
      //push empty if sorted not empty
      if (sorted.length > 0) {
        let emptyRow = {}
        for (let key in data[0]) {
          emptyRow[key] = 'empty'
        }
        sorted.push(emptyRow)
      }
      // push only isBasic!=true
      for (let key in data) {
        if (data[key].isBasic != true) {
          sorted.push(data[key])
        }
      }

      return sorted
    },
  },
  computed: {
    ...mapGetters([
      'POSITIONS_DATA',
      'CURRENT_PAGE',
      'AMOUNT_PAGE',
      'TOTAL_ROWS',
      'PER_PAGE',
      'SITE_LIST',
      'REGION_LIST',
      'PER_PAGE',
      'SEARCH_VALUE',
      'CURRENT_REGION_DATA',
      'SORT_DIR',
      'SORT_FIELD',
      'HISTORY_DATA',
      'FIELD_HEADER',
    ]),
    getCurrentDomain() {
      for(let key in this.SITE_LIST) {
        if (this.SITE_LIST[key].value == this.currentSiteId) {
          return this.SITE_LIST[key].text
        }
      }

      return 'false'
    }
  },
  watch: {
    currentSiteId(newVal) {
      // this.chartName = ''
      this.$store.commit('sites/positions/CURRENT_SITE_ID', newVal);
      this.$store.commit('sites/positions/CURRENT_REGION_ID', null);
      this.$store.commit('sites/positions/CURRENT_REGION_DATA', {});
      this.$store.commit('sites/positions/HISTORY_DATA', {});
      this.$store.commit('sites/positions/CURRENT_PAGE', 1)
      this.GET_DATA({th: this})
    },
    currentSearchEngine(newVal) {
      // this.chartName = ''
      this.$store.commit('sites/positions/CURRENT_SEARCH_ENGINE', newVal);
      this.$store.commit('sites/positions/CURRENT_REGION_ID', null);
      this.$store.commit('sites/positions/REGION_LIST', []);
      this.$store.commit('sites/positions/CURRENT_REGION_DATA', {});
      this.$store.commit('sites/positions/HISTORY_DATA', {});
      this.$store.commit('sites/positions/CURRENT_PAGE', 1)
      this.GET_DATA({th: this})
    },
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('sites') === -1) {
      this.$router.push({name: 'permissionDenied'})
      return
    }
  },
  created() {
    this.$store.commit('sites/positions/CURRENT_SITE_ID', this.currentSiteId)
    this.initPageSize()
    this.GET_DATA({th: this})
  }
}
</script>

<style scoped>
.search-box {
  width: 375px;
  float: left
}
.total-search-box {
  width: 525px;
}
.query-link {
  color: #007bff;
  text-decoration: none;
  background-color: transparent;
  cursor: pointer;
}
.query-link:hover {
  text-decoration: underline;
}
.chart-col {
  position: fixed;
  width: 500px;
  margin: auto;
}
.chart-box {
  width: 600px;
  display: block;
}
</style>

<style>

</style>